<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Add voucher'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="numberForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" *ngIf="!loadingVouchers">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="20" *ngIf="!firstTimeVoucher">
                    <mat-label>{{'Quantity'|translate}}</mat-label>
                    <input name="quantity" formControlName="quantity" matInput required>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="{{firstTimeVoucher?'100':'80'}}" class="pr-4">
                    <mat-label>{{'Voucher'|translate}}</mat-label>
                    <mat-select formControlName="voucher">
                        <mat-option [value]="voucher" *ngFor="let voucher of vouchers">
                            {{voucher.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" *ngIf="!firstTimeVoucher">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Expiration date'|translate}}</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="expirationDate" (dateChange)="onDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </form>

        <div *ngIf="loadingVouchers">
            {{'Loading'|translate}}...
        </div>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(numberForm)"
                aria-label="Save">
            {{'Add'|translate}}
        </button>

    </div>
</div>
